export default __webpack_public_path__ + "static/media/piece4.ed2bb3a9.png";